import { publicCredit } from "./publicCredit";
import { getPublicUser } from "./getPublicUser";
import { createPublicCustomer } from "./createPublicCustomer";
import { createPublicTransaction } from "./createPublicTransaction";
import { increaseEntryCount } from "./increaseEntryCount";
import { getAllUserLinks } from "./getAllUserLinks";
import { getByIdLink } from "./getByIdLink";
import { getChartLink } from "./getChartLink";
import { checkName } from "./checkName";
import { createLink } from "./createLink";

export const selfHireService = {
  publicCredit,
  getPublicUser,
  createPublicCustomer,
  createPublicTransaction,
  increaseEntryCount,
  getAllUserLinks,
  getByIdLink,
  getChartLink,
  checkName,
  createLink,
};
